import axios from 'axios';

export default {
    list(offset, limit) {
        return axios.post('/paintworkorder/list/', {
            offset,
            limit,
        });
    },
    create(paintlistIds, updateProductStatus = false) {
        const payload = {
            updateProductStatus,
        };
        paintlistIds.forEach((x, i) => {
            payload['paintlist' + i] = x;
        });
        return axios.post('/paintworkorder/create/', payload);
    },
    detail(paintworkorderId) {
        return axios.post('/paintworkorder/detail/', { paintworkorderId });
    },
    listLatest(withoutSawn, paintshop = null) {
        return axios.post('/paintworkorder/listLatest/', {
            withoutSawn,
            paintshop,
        });
    },
    createFromExpress(updateProductStatus, paintshop = null) {
        return axios.post('/paintworkorder/createFromExpress/', {
            updateProductStatus,
            paintshop,
        });
    },
    createFromPleating(updateProductStatus, paintshop = null) {
        return axios.post('/paintworkorder/createFromPleating/', {
            updateProductStatus,
            paintshop,
        });
    },
    createFromErrors(updateProductStatus, paintshop = null) {
        return axios.post('/paintworkorder/createFromErrors/', {
            updateProductStatus,
            paintshop,
        });
    },
    fetchLatest() {
        return axios.post('/paintworkorder/fetchLatest/');
    },
};
